import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { snapToFrame } from './base-animation';
import { getOffset } from '../helpers/functions';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const slider = () => {
  const $benefits = document.querySelectorAll('.benefit');
  if (!$benefits.length) return;
  const benefitAnimation = ($el, isLast) => {
    snapToFrame($el);
    gsap.to($el, {
      scale: 0.8,
      filter: 'blur(10px)',
      opacity: 0,
      scrollTrigger: {
        trigger: $el,
        scrub: true,
        pin: !isLast,
        start: 'top',
        pinSpacing: false
      }
    });
  };
  $benefits.forEach($benefit => {
    const $sections = $benefit.querySelectorAll('.benefit-section');
    const $navLinks = $benefit.querySelectorAll('.tns-nav a');
    [...$navLinks].forEach($navLink => {
      const id = $navLink.getAttribute('href');
      const {
        top
      } = getOffset(document.querySelector(id));
      $navLink.addEventListener('click', e => {
        e.preventDefault();
        gsap.to(window, {
          duration: 1,
          scrollTo: top
        });
      });
    });
    [...$sections].forEach(($section, index) => {
      benefitAnimation($section, index === $sections.length - 1);
    });
  });
};
export default slider;